import * as queueConstants from './queue/constants'
import * as settingsConstants from './settings/constants'
import * as toastsConstants from './toasts/constants'

// eslint-disable-next-line
export const constants = {
    queue: queueConstants,
    settings: settingsConstants,
    toasts: toastsConstants,
}



// WEBPACK FOOTER //
// ./src/features/Toaster/data/constants.js